export default __webpack_public_path__ + "static/ceinture.inspirations-242652a50830c398c0e8399b74051411.jpg";